import './ToastContainer.css';
export var toastsCSS = '_1foxprc3-2-0-1';